import Image1 from '../../assets/Acces_internet_APP1.PNG'
import Image2 from '../../assets/project2.jpg'
import Image3 from '../../assets/project3.jpg'
import Image4 from '../../assets/project4.jpg'
import Image5 from '../../assets/project5.jpg'
import Image6 from '../../assets/project6.jpg'
import Image7 from '../../assets/project7.jpg'
import Image8 from '../../assets/K8s-Deployment1.jpg'
import Image9 from '../../assets/project9.jpg'
import Image10 from '../../assets/Hire_Django_dev1.png'
import Image11 from '../../assets/MLOPS_MLFLOW.png'

const data = [
    {
        id: 1,
        category: 'devOps',
        image: Image1,
        title: "DevOps Engineer Orchestrating Health Supplies Management",
        desc: "The DevOps engineer ensures seamless integration, deployment, and scaling for the Health Supplies Management project, utilizing Django, React, Docker, Jenkins, AWS Cloud, Kubernetes (EKS), Terraform, and Prometheus for robust monitoring.",
        demo: 'http://egatortutorials.com',
        github: 'https://github.com/egattor'
    },

    {
        id: 2,
        category: 'devOps',
        image: Image2,
        title: "AWS Internship: CI/CD, Kubernetes Deployment, Infrastructure Optimization Mastery.",
        desc: "During the internship, I led the implementation of a robust CI/CD pipeline, orchestrated Ecommerce ProShop deployment on a Kubernetes cluster, and optimized infrastructure using AWS, EC2, Kubernetes, Gitlab CI, Terraform, and Prometheus.",
        demo: 'http://egatortutorials.com',
        github: 'https://github.com/egattor'
    },

    {
        id: 3,
        category: 'devOps',
        image: Image3,
        title: "Intern Impact: CI/CD, Kubernetes, GCP Mastery.",
        desc: "Internship focus: Implemented CI/CD, orchestrated Kubernetes deployment for Finger-print application, optimizing GCP infrastructure with Gitlab CI, Terraform, and Prometheus.",
        demo: 'http://egatortutorials.com',
        github: 'https://github.com/egattor'
    },

    {
        id: 4,
        category: 'devOps',
        image: Image4,
        title: "AWS CI/CD, Kubernetes Deployment Success.",
        desc: "Internship achievements include a streamlined CI/CD pipeline using AWS (EC2) and Kubernetes, deploying the Finger-print application with Gitlab CI for efficient and automated delivery.",
        demo: 'http://egatortutorials.com',
        github: 'https://github.com/egattor'
    },
    {
        id: 5,
        category: 'django_backend',
        image: Image5,
        title: "Hardware Management : ENI Intern to build django web app",
        desc: "Internship at ENI involved spearheading the design and implementation of a hardware management application, integrating Django for backend, REACT for frontend, and PostGresql for the database",
        demo: 'http://egatortutorials.com',
        github: 'https://github.com/egattor'
    },
    {
        id: 6,
        category: 'devOps',
        image: Image6,
        title: "DevOps Impact: GCP, Kubernetes Mastery.",
        desc: "DevOps engineer contribution to Assignment Management and Interester project involved Django web development, Docker containerization, Jenkins CI, GCP Cloud for scalable infrastructure, and Kubernetes for container orchestration.",
        demo: 'http://egatortutorials.com',
        github: 'https://github.com/egattor'
    },
    
    {
        id: 7,
        category: 'django_backend',
        image: Image7,
        title: "Finger-Print web App : Backend Development",
        desc: "Internship at ENI as a BackEnd Django developer involved implementing a student checkpointing management system, utilizing Django for the backend, React for the frontend, PostGreSQL for the database, and JupiterLab for collaborative work.",
        demo: 'http://egatortutorials.com',
        github: 'https://github.com/egattor'
    },
    {
        id: 8,
        category: 'devOps',
        image: Image8,
        title: "Student Checkpoint: Kubernetes Deployment",
        desc: "Internship focus: Spearheaded student checkpointing management platform deployment using Kubernetes, Docker, Postgresql, Django, Angular, Docker Hub, and Prometheus for efficient and collaborative platform management.",
        demo: 'http://egatortutorials.com',
        github: 'https://github.com/egattor'
    },
    {
        id: 9,
        category: 'django_backend',
        image: Image9,
        title: "Ecommerce App: React, Django Deployment.",
        desc: "In this project, I undertook the creation and deployment of an Ecommerce App using React Js for the frontend, Django for the backend, and PostGresql for database management.",
        demo: 'http://egatortutorials.com',
        github: 'https://github.com/egattor'
    },
    {
        id: 10,
        category: 'django_backend',
        image: Image10,
        title: "Talent Hiring: Django Deployment ",
        desc: "I led the creation and deployment of a Talent Hiring platform, employing Django for the backend and leveraging PostGresql for robust database management.",
        demo: 'http://egatortutorials.com',
        github: 'https://github.com/egattor'
    } ,
    {
        id: 11,
        category: 'mlOps',
        image: Image11,
        title: "ML Deployment: Docker, FastAPI Mastery Project.",
        desc: "Developing an end-to-end machine learning project, this MLOps implementation utilizes Docker and FastAPI to package, interface, and automate testing of a random forest regressor on the Kaggle Boston House Prices dataset.",
        demo: 'http://egatortutorials.com',
        github: 'https://github.com/egattor'
    },
]


export default data